"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createValidator = void 0;
const validator_ajv8_1 = require("@rjsf/validator-ajv8");
const rewriteSchema_1 = require("../rewriteSchema/rewriteSchema");
const createValidator = () => {
    const customizedOptions = {
        ajvOptionsOverrides: {
            formats: {
                'matrix-asset-uri': /^matrix-asset:\/\//,
                'multi-line': true,
            },
            keywords: [
                {
                    // Leave the input UI/logic to ensure the data is in a valid format.
                    // Just make sure the data is not empty, this logic is hit if a field is either:
                    // 1. Filled
                    //     -> In this case the "data" won't be undefined so will always be valid.
                    // 2. An array item (regardless of if it is filled)
                    //     -> In this case the "data" may be undefined so may or may not be valid.
                    keyword: 'customType',
                    validate: (_, data) => typeof data !== 'undefined',
                    error: {
                        message: 'Must be filled',
                    },
                },
            ],
        },
    };
    const validator = (0, validator_ajv8_1.customizeValidator)(customizedOptions);
    const originalValidateFormData = validator.validateFormData;
    // If a schema is being programmatically validated it may not have custom
    // types rewritten or missing required fields dropped from validation.
    // Override validation function and rewrite schema dynamically.
    // https://squizgroup.atlassian.net/browse/FEAAS-497
    // https://squizgroup.atlassian.net/browse/FEAAS-685
    validator.validateFormData = (formData, schema, ...other) => {
        return originalValidateFormData.call(validator, formData, (0, rewriteSchema_1.rewriteSchema)(schema), ...other);
    };
    return validator;
};
exports.createValidator = createValidator;
//# sourceMappingURL=createValidator.js.map